module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag32_1582AT.9e97f327.jpg";